import { toJS } from 'mobx';
import { ORDER_STATUS } from 'src/constants/order';
import { history } from 'src/services/history';
import { CheckoutStore } from '~/mobx/checkoutStore';
import { localeStore } from '~/mobx/localesStore';
import { CallCenterStore } from '~/mobx/ordersStore/callCenterStore';
import { PRODUCT_ORDER_TYPE } from '~/types/product';
import { IMenuProduct } from '~/types/products';
import { isOrderTypeSupported } from '~/utils/helpers';
import getOrderViewPath from '~/view/screens/CheckoutScreen/getOrderViewPath';
import getOrdersPath from '~/view/screens/CheckoutScreen/getOrdersPath';
import { productTypeErrorMessages } from '~/view/screens/MenuManagementScreen/screens/ItemsScreen/constants/items';

export const discardCb = (checkoutStore: CheckoutStore) => {
  if (!checkoutStore.dependencies?.order) return;

  if (checkoutStore.dependencies.order?.order_status_code === ORDER_STATUS.DRAFT && checkoutStore.parentStore instanceof CallCenterStore) {
    checkoutStore.parentStore.deleteDraft(String(checkoutStore.dependencies.order.id));
    history.push(getOrdersPath(checkoutStore.parentStore));
  } else {
    history.push(getOrderViewPath(checkoutStore.parentStore, checkoutStore.dependencies.order.id), toJS(checkoutStore.dependencies.order));
  }
};

export const getProductErrorMessage = (product: IMenuProduct | undefined, supportedType: PRODUCT_ORDER_TYPE): string => {
  let message: string = product?.error ?? '';

  if (!product || product.error) return message.toUpperCase();

  switch (true) {
    case !product.status:
      message = 'not_available';
      break;
    case !!product.out_of_stock:
      message = 'out_of_stock';
      break;
    case product.order_type !== undefined && !isOrderTypeSupported(product.order_type, supportedType):
      message = productTypeErrorMessages[supportedType];
  }
  if (!message) return '';
  return localeStore.t(message).toUpperCase();
};
